/**
 * The date range the coaching calls calendar loads: ±3 months around today, so
 * a viewer can scrub forward (next quarter of upcoming calls) or back (sessions
 * that just happened). Server-side filtering keeps the payload bounded.
 *
 * This lives outside the page module so the route loader can prefetch the query
 * without pulling the page's lazy chunk into the initial bundle. The bounds are
 * month-granular, so the loader and the page build an identical window — and
 * therefore hit the same React Query key — rather than fetching twice.
 */
export function buildCoachingCallsWindow(): { from: string; to: string } {
  const now = new Date()
  const from = new Date(now.getFullYear(), now.getMonth() - 3, 1).toISOString()
  const to = new Date(now.getFullYear(), now.getMonth() + 4, 1).toISOString()
  return { from, to }
}
